// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploadBtn[data-v-59fb62b3]{display:flex;justify-content:center;align-items:center}[data-v-59fb62b3] .el-upload,[data-v-59fb62b3] .el-upload-dragger{width:100%}", ""]);
// Exports
module.exports = exports;
